import React from 'react'
import { formatearFecha, formatosFecha } from 'util/formatDate'
import { setearMilesFixed } from 'util/funciones'
import { ISellRecaudoTicket } from './interface'
import { objetoVacio } from 'util/utils'

interface IProps {
     ticket: ISellRecaudoTicket | ISellRecaudoTicket
     imageRef: React.RefObject<HTMLImageElement>
     logoBase: string
     setLogoBase: React.Dispatch<React.SetStateAction<string>>
     setIsImageLoaded: React.Dispatch<React.SetStateAction<boolean>>
}

const SellRecaudoTicket = ({ ticket, imageRef, logoBase, setLogoBase, setIsImageLoaded }: IProps) => {
     return (
          <div>
               <div className="receipt__text--center">
                    <img
                         ref={imageRef}
                         src={logoBase || "/placeholder.svg"}
                         alt="Iter México"
                         style={{ height: "7rem", marginBottom: "18px" }}
                         onLoad={() => setIsImageLoaded(true)}
                         onError={() => {
                              console.error("Error loading image")
                              setLogoBase("/placeholder.svg")
                              setIsImageLoaded(true)
                         }}
                    />
                    <p>{ticket.empresa.razon_social}</p>
                    <p>{ticket.empresa.alias}</p>
                    <p>{ticket.empresa.direccion}</p>
                    <p>TEL: {ticket.empresa.telefono}</p>
                    <p>{ticket.empresa.correo}</p>
                    <p>RFC: {ticket.empresa.nit}</p>
               </div>

               <div className="receipt__separator"></div>
               <div className="receipt__separator"></div>
               <table className="receipt__table">
                    <tbody>
                         <tr>
                              <td>ORIGEN:</td>
                              <td>REPORTE WEB</td>
                         </tr>
                    </tbody>
               </table>

               <div className="receipt__separator"></div>
               <div className="receipt__separator"></div>

               <table className="receipt__table">
                    <tbody>
                         <tr>
                              <td>NRO DE TICKET:</td>
                              <td>{ticket.numero_ticket}</td>
                         </tr>
                         <tr>
                              <td>TIPO AUTORIZACION:</td>
                              <td>{ticket.tipo_autorizacion}</td>
                         </tr>
                         <tr>
                              <td>FECHA IMPRESION:</td>
                              <td>{formatearFecha(new Date(), formatosFecha.completa2)}</td>
                         </tr>
                         <tr>
                              <td>FECHA VENTA:</td>
                              <td>{formatearFecha(ticket.fecha_generacion, formatosFecha.completa2)}</td>
                         </tr>
                         <tr>
                              <td>PROMOTOR:</td>
                              <td>{ticket.promotor}</td>
                         </tr>
                         <tr>
                              <td>TURNO:</td>
                              <td>{ticket.jornada}</td>
                         </tr>
                    </tbody>
               </table>

               <table className="receipt__table">
                    <tbody>
                         <tr>
                              <td>POS:</td>
                              <td>ISLA:</td>
                              <td>SURTIDOR:</td>
                              <td>CARA:</td>
                              <td>MANGUERA:</td>
                         </tr>
                         <tr>
                              <td>{ticket.pos}</td>
                              <td>{ticket.isla}</td>
                              <td>{ticket.surtidor}</td>
                              <td>{ticket.cara}</td>
                              <td>{ticket.manguera}</td>
                         </tr>
                    </tbody>
               </table>
               <div className="receipt__separator"></div>
               <div className="receipt__separator"></div>

               <table className="receipt__table">
                    <tbody>
                         <tr>
                              <td>CLIENTE:</td>
                              <td>{ticket.cliente.nombres}</td>
                         </tr>
                         <tr>
                              <td>IDENTIFICACION:</td>
                              <td>{ticket.cliente.identificacion}</td>
                         </tr>
                         <tr>
                              <td>PLACA:</td>
                              <td>{ticket.cliente.placa}</td>
                         </tr>
                         <tr>
                              <td>SERIAL:</td>
                              <td>{ticket.serial_medio_autorizacion}</td>
                         </tr>
                    </tbody>
               </table>

               <div className="receipt__separator"></div>
               <div className="receipt__separator"></div>

               <table className="receipt__table">
                    <thead>
                         <tr>
                              <th className="receipt__table-header">PRODUCTO</th>
                              <th className="receipt__table-header">PRECIO</th>
                              <th className="receipt__table-header">CANTIDAD</th>
                              <th className="receipt__table-header">TOTAL</th>
                         </tr>
                    </thead>
                    <tbody>
                         <tr>
                              <td className="receipt__table-cell">{ticket.producto}</td>
                              <td className="receipt__table-cell">${setearMilesFixed(Number(ticket.precio))}</td>
                              <td className="receipt__table-cell">{ticket.cantidad} LT</td>
                              <td className="receipt__table-cell">${setearMilesFixed(Number(ticket.venta_total))}</td>
                         </tr>
                    </tbody>
               </table>

               <div className="receipt__separator"></div>
               <div className="receipt__separator"></div>

               <div className="text-center">DETALLES MEDIOS DE PAGO</div>

               <table className="receipt__table">
                    <thead>
                         <tr>
                              <th className="receipt__table-header">MEDIO DE PAGO</th>
                              <th className="receipt__table-header">TOTAL M. PAGO</th>
                              <th className="receipt__table-header">RECIBIDO</th>
                              <th className="receipt__table-header">CAMBIO</th>
                         </tr>
                    </thead>
                    <tbody>
                         {ticket.medios_pago.map((mPago, i) => (
                              <tr key={i}>
                                   <td className="receipt__table-cell">{mPago.descripcion}</td>
                                   <td className="receipt__table-cell">${setearMilesFixed(Number(mPago.valor_total))}</td>
                                   <td className="receipt__table-cell">${setearMilesFixed(Number(mPago.valor_recibido))}</td>
                                   <td className="receipt__table-cell">${setearMilesFixed(Number(mPago.valor_cambio))}</td>
                              </tr>
                         ))}
                    </tbody>
               </table>

               <div className="receipt__separator"></div>
               <div className="receipt__separator"></div>

               {
                    !objetoVacio(ticket.recaudo) ? (<>
                         <div className="text-center">RECAUDO</div>

                         <table className="receipt__table">
                              <thead>
                                   <tr>
                                        <th className="receipt__table-header">TOTAL RECAUDO X LT</th>
                                        <th className="receipt__table-header">TOTAL RECAUDO</th>
                                   </tr>
                              </thead>
                              <tbody>
                                   <tr>
                                        <td className="receipt__table-cell">{ticket.recaudo.cantidad}</td>
                                        <td className="receipt__table-cell">${setearMilesFixed(Number(ticket.recaudo.valor))}</td>
                                   </tr>
                              </tbody>
                         </table>

                         <div className="receipt__separator"></div>
                         <div className="receipt__separator"></div>

                         <div className="text-center">RECAUDO DETALLADO</div>

                         <table className="receipt__table">
                              <thead>
                                   <tr>
                                        <th className="receipt__table-header">CONCEPTO</th>
                                        <th className="receipt__table-header">VALOR</th>
                                        <th className="receipt__table-header">MONTO</th>
                                   </tr>
                              </thead>
                              <tbody>
                                   {ticket.recaudos_detallado.map((detalle, i) => (
                                        <tr key={i}>
                                             <td>{detalle.descripcion}</td>
                                             <td>{detalle.valor_concepto}</td>
                                             <td>${detalle.monto}</td>
                                        </tr>
                                   ))}
                              </tbody>
                         </table>

                         <div className="receipt__separator"></div>
                         <div className="receipt__separator"></div>

                    </>) : <></>
               }

               <table className="receipt__table">
                    <tbody>
                         <tr>
                              <td className="receipt__table-cell">TOTAL:</td>
                              <td className="receipt__table-cell">${setearMilesFixed(Number(ticket.venta_total))}</td>
                         </tr>
                    </tbody>
               </table>
               <div className="">
                    {ticket.valor_venta_texto}
               </div>

               <div className="receipt__separator"></div>


               <div className="text-center text-xs mt-2">
                    {ticket.footer_ticket}
               </div>
          </div>
     )
}

export default SellRecaudoTicket